
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { defineComponent } from 'vue'
import { PageData } from '@interfaces/PageDataTypes'

export default defineComponent({
  name: 'AcademicResearchPage',
  layout: 'resources',
  extends: MachinationsLightPage,
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Academic Research`,
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  async asyncData(context) {
    const { store } = context
    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'academic-research-publications',
    })
    await store.dispatch('common/setupPageLight', { context })
    store.commit('wp/updatePageContent', '<h1>Academic Research</h1>')
    return {
      pageData,
    }
  },
  computed: {
    resources() {
      return this.$store.state.wp.acfData.resources || []
    },
    pageContent() {
      return this.$store.state.wp.pageContent || 'undefined'
    },
    commonMenu() {
      return this.$store.state.common.menu
    },
  },
})
